$(".accordion-title").click(function(){
  $(this).toggleClass("active");
  $(this).siblings(".swatch-full").slideToggle( "slow", function() {
    // Animation complete.
  });
});

// $(".complete-look-gallery-cell").flickity({
//         "lazyLoad": 2,
//         "imagesLoaded": true,
//         "draggable": true,
//         "cellAlign": "left",
//         "prevNextButtons": true,
//         "wrapAround": true,
//         "pageDots": false,
//         "contain": false,
//         "freeScroll": false,
//         groupCells: 3,
//         "arrowShape": { 
//           x0: 10,
//           x1: 55, y1: 45,
//           x2: 60, y2: 40,
//           x3: 60
//         }
//       });

$(".toggle, .sidebar__collection-filter").click(function(){
  $(this).parent().toggleClass("custom-sidebar-block");
});

/*--Shop by bra page size sorting--*/

 function numerically(a,b){
   var a_val = parseInt( $('a', a).text(), 10 );
   var b_val = parseInt( $('a', b).text(), 10 );
   //console.log(a_val - b_val);
   return  a_val - b_val; 
  }
 
  $('.size-chart-another').each(function() {
    $(this).children('.swatch-element').sort( numerically ).prependTo($(this));
  });

